<script>
    import { marked } from 'marked';
    // import url from '../../stores/url';
    export let source;

    // update sourceMap functions
    export let updateSourceMap;
    let markdown;
    let lastHashtag;
    
  class MySet extends Set {
    add(value) {
      super.add(value);
      this.last = value;
    }
  }

  let hashtags = new MySet();

  const myInlineDescription = {
    name: 'hashtag',
    level: 'inline',                                 // Is this a block-level or inline-level tokenizer?
    start(src) { return src.match(/#/)?.index; },    // Hint to Marked.js to stop and check for a match
    tokenizer(src, tokens) {
      const rule = /^\B(\#[a-zA-Z0-9]{3,}\b)/;  // Regex for the complete token, anchor to string start
      const match = rule.exec(src);
      if (match) {
        return {                                         // Token to generate
          type: 'hashtag',                           // Should match "name" above
          raw: match[0],
          text: match[1].trim(),                          // Text to consume from the source
          index: match.index,
          // dt: this.lexer.inlineTokens(match[1].trim()),  // Additional custom properties, including
          // dd: this.lexer.inlineTokens(match[2].trim())   //   any further-nested inline tokens
        };
      }
    },
    renderer(token) {
      // return `\n<dt>${this.parser.parseInline(token.dt)}</dt><dd>${this.parser.parseInline(token.dd)}</dd>`;
      return `<span><a class="tag-link" href="${token.text}">${token.text}</a></span>`
    },
    // childTokens: ['dt', 'dd'],                 // Any child tokens to be visited by walkTokens
  };

  const walkTokens = (token) => {
    if (token.type === 'hashtag') {
      hashtags.add(token.text);
      lastHashtag = hashtags.last;
    }
  }

  marked.use({ extensions: [myInlineDescription], walkTokens })

  // marked.use({
    // tokenizer,
    // renderer,
    // extensions: [description, hashtagger],
    // walkTokens
  // })


$: {
  if (source) {
    markdown = marked(source);
  }
}

const onSourceChange = (e) => {
    updateSourceMap(source);
}
</script>

<main>

    <div style="display:flex;">
      <div style="flex: 0 0 50%;">
        <textarea 
            bind:value={source}
            on:input={e => onSourceChange(e)}
            placeholder="Enter markdown here"
        />
      </div>
      
      <div style="flex: 0 0 50%;" class="html-output-container">
        <div>{@html markdown}</div>
      </div>
    </div>
</main>

<style>
	
	textarea {
		font-family: monospace, Roboto;
		height: 100%;
		border: none;
		margin: 0;
		padding: 1rem;
        box-sizing: border-box;
		display: block;
        /* color: rgb(150, 150, 150); */
        background: rgb(200,200,200);
	}
    .html-output-container {
        color: rgb(150, 150, 150);
        font-size: 24px;
    }
    .tag-link {
        color: #2a7e19 !important;
    }
</style>